import { ActionType } from './action';

function bookmarksReducer(bookmarks = [], action = {}) {
  switch (action.type) {
    case ActionType.RECEIVE_BOOKMARKS:
      return action.payload.bookmarks;
    case ActionType.ADD_BOOKMARK:
      return [action.payload.bookmark, ...bookmarks];
    case ActionType.DELETE_BOOKMARK:
      return bookmarks.filter((bookmark) => bookmark.id !== action.payload);
    default:
      return bookmarks;
  }
}

export default bookmarksReducer;
